<script setup lang="ts">
import useCompanyName from '@Use/useCompanyName';
import { ErrorScreenLayout, SupportEmailLink } from '@Shared';
import BrowserError from '@Assets/images/browser_error.svg';

const { companyName } = useCompanyName();
</script>

<template>
    <div class="identity-unverified-view">
        <div class="identity-unverified-view__content">
            <error-screen-layout
                :image="BrowserError"
                image-alt="We couldn't verify your identity"
                title="We couldn't verify your identity"
                image-width="12rem"
                image-height="10rem">
                <p>
                    We weren't able to verify your identity for this request.
                </p>
                <p>
                    {{ companyName }} has been notified. They will reach out directly with next steps.
                    If you have any technical issues, please contact <support-email-link />.
                </p>
            </error-screen-layout>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.identity-unverified-view {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    @include desktop {
        padding-top: 10.25rem;
    }

    &__content {
        border-radius: 0.25rem;
        background-color: $white;
        max-width: 24.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        line-height: 150%;
        color: $black-high;
    }
}
</style>
